import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {DARK_THEME} from '../../constants'

function getIconThemeColor (theme) {
  if (theme === DARK_THEME) {
    return '#bfccd6'
  } else {
    return '#5c7080'
  }
}

class SVGIcon extends React.Component {

  render() {
    const color = getIconThemeColor(this.props.theme);
    const width = this.props.width;
    const height = this.props.height;
    return (
      <svg xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 384 512"
           width={width} height={height}
           fill={color}
      >
        {this.props.path}
      </svg>
    )
  }
}

function mapStateToProps(state) {
  return {
    theme: state.theme
  }
}

SVGIcon.propTypes = {
  path: PropTypes.node.isRequired,
  viewBox: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
};

SVGIcon.defaultProps = {
  width: 16,
  height: 16
};

SVGIcon = connect(mapStateToProps, null)(SVGIcon);

export default SVGIcon;



// WEBPACK FOOTER //
// ./src/containers/Subtitles/SVGIcon.js